import { useState, useEffect } from "react";

import api from "../../utilities/api";

const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("de-CH", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const BackupsPanel = () => {
  const [backups, setBackups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBackups = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/backups`);
        setBackups(response.data);
        setError(null);
      } catch (err) {
        console.error("Error fetching backups:", err);
        setError("Failed to load backups");
      } finally {
        setLoading(false);
      }
    };
    fetchBackups();
  }, []);

  if (loading) {
    return <p className="text-gray-500 p-4">Loading backups…</p>;
  }

  if (error) {
    return <p className="text-red-600 p-4">{error}</p>;
  }

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-4">Backups</h2>
      <p className="text-gray-700 mb-4">
        Every night a backup of the whole database is created. After 30
        backups the oldest backup will be deleted. The backup is initiated from
        outside the application. If you need a restore of a former version of
        the database, please write an email to{" "}
        <a
          href="mailto:businessoffice@openfunds.org"
          className="text-cyan-900 underline hover:text-cyan-700"
        >
          businessoffice@openfunds.org
        </a>
        .
      </p>

      {backups.length === 0 ? (
        <p className="text-gray-500">No backups found</p>
      ) : (
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full py-2 align-middle">
            <table className="min-w-full text-left">
              <thead className="bg-cyan-900 text-white">
                <tr>
                  <th className="py-2 px-2">Date/Time</th>
                  <th className="py-2 px-2">Backup File</th>
                  <th className="py-2 px-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {backups.map((backup, i) => (
                  <tr
                    key={backup._id}
                    className={i % 2 === 0 ? "bg-slate-100" : "bg-slate-300"}
                  >
                    <td className="py-1 px-2">
                      {formatDateTime(backup.timestamp)}
                    </td>
                    <td className="py-1 px-2">{backup.file}</td>
                    <td
                      className={`py-1 px-2 font-medium ${
                        backup.status === "success"
                          ? "text-green-700"
                          : "text-red-700"
                      }`}
                    >
                      {backup.status}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default BackupsPanel;
